<template lang="pug">
div
  v-row.monitorsys-row
    v-col(
      v-for="card in summaryCards",
      :key="card.key",
      cols="12",
      md="4"
    )
      summary-card(
        :title="card.title",
        :value="card.value",
        :variant="card.variant"
      )

  v-row.monitorsys-row
    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Volume de solicitações por período
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitorsys-action-button",
            @click="dialogs.volume = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="volumeSeries.length",
            :key="volumeRenderKey",
            type="line",
            :options="volumeChartOptions",
            :series="volumeSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Distribuição de solicitações por status
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitorsys-action-button",
            @click="dialogs.interacoes = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="interacoesSeries.length",
            type="bar",
            :options="interacoesChartOptions",
            :series="interacoesSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

  v-row.monitorsys-row
    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Ranking de supervisores por interações
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitorsys-action-button",
            @click="dialogs.supervisores = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="supervisoresSeries.length",
            type="bar",
            :options="supervisoresChartOptions",
            :series="supervisoresSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Ranking de usuários com mais solicitações
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitorsys-action-button",
            @click="dialogs.usuarios = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="usuariosSeries.length",
            type="bar",
            :options="usuariosChartOptions",
            :series="usuariosSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.volume",
    @input="dialogs.volume = $event",
    content-class="monitorsys-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Volume de solicitações por período
        v-btn(icon, @click="dialogs.volume = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="volumeSeries.length",
          :key="volumeDialogRenderKey",
          type="line",
          :options="volumeDialogOptions",
          :series="volumeSeries",
          height="520"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.interacoes",
    @input="dialogs.interacoes = $event",
    content-class="monitorsys-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Interação das solicitações
        v-btn(icon, @click="dialogs.interacoes = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="interacoesSeries.length",
          type="bar",
          :options="interacoesDialogOptions",
          :series="interacoesSeries",
          height="520"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.supervisores",
    @input="dialogs.supervisores = $event",
    content-class="monitorsys-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Ranking de supervisores por interações
        v-btn(icon, @click="dialogs.supervisores = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="supervisoresDialogSeries.length",
          type="bar",
          :options="supervisoresDialogOptions",
          :series="supervisoresDialogSeries",
          :height="rankingDialogHeight(supervisoresItems)"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.usuarios",
    @input="dialogs.usuarios = $event",
    content-class="monitorsys-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Ranking de usuários com mais solicitações
        v-btn(icon, @click="dialogs.usuarios = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="usuariosDialogSeries.length",
          type="bar",
          :options="usuariosDialogOptions",
          :series="usuariosDialogSeries",
          :height="rankingDialogHeight(usuariosItems)"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.
</template>

<script>
import SummaryCard from "@/components/dashboards/shared/SummaryCard";

const STATUS_COLORS = {
  aprovadas: "#2e7d32",
  negadas: "#c62828",
  canceladas: "#ef6c00",
  sem_supervisor: "#5e35b1",
  erro: "#6d4c41",
  criadas: "#546e7a"
};
const VOLUME_COLORS = {
  total: "#1e88e5",
  aprovadas: "#2e7d32",
  negadas: "#c62828",
  outros: "#7e57c2"
};
const RANKING_COLOR = "#3b4c63";
const INITIAL_RANKING_LIMIT = 10;
const RANKING_DIALOG_MIN_HEIGHT = 520;
const RANKING_DIALOG_BAR_HEIGHT = 44;
const NUMBER_FORMATTER = new Intl.NumberFormat("pt-BR");

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function sortByMetricDesc(items, metricKey) {
  return toArray(items)
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const diff =
        toNumber((b.item && b.item[metricKey]) || 0) - toNumber((a.item && a.item[metricKey]) || 0);
      if (diff !== 0) return diff;
      return a.index - b.index;
    })
    .map(entry => entry.item);
}

function formatInteger(value) {
  return NUMBER_FORMATTER.format(Math.round(toNumber(value)));
}

function formatTimestampBR(value) {
  if (value === null || value === undefined || value === "") return "";

  const raw =
    typeof value === "number"
      ? value
      : typeof value === "string" && /^\d+$/.test(value)
      ? Number(value)
      : value;

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return "";

  const day = String(parsed.getDate()).padStart(2, "0");
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const year = parsed.getFullYear();
  return `${day}/${month}/${year}`;
}

function createVolumeChartOptions(chartHeight, tickAmount) {
  return {
    chart: {
      type: "line",
      height: chartHeight,
      parentHeightOffset: 0,
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    colors: [
      VOLUME_COLORS.total,
      VOLUME_COLORS.aprovadas,
      VOLUME_COLORS.negadas,
      VOLUME_COLORS.outros
    ],
    stroke: { curve: "monotoneCubic", width: 2.5 },
    markers: { size: 2.5, strokeWidth: 0, hover: { size: 4 } },
    grid: {
      borderColor: "#dfe7f5",
      strokeDashArray: 4
    },
    dataLabels: { enabled: false },
    legend: { show: true, position: "top", horizontalAlign: "center" },
    xaxis: {
      type: "datetime",
      tickAmount,
      axisBorder: { show: true },
      axisTicks: { show: true },
      crosshairs: { show: true },
      tooltip: { enabled: false },
      labels: {
        rotate: 0,
        datetimeUTC: false,
        formatter: value => formatTimestampBR(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      labels: {
        formatter: value => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      followCursor: false,
      x: {
        show: true,
        formatter: value => formatTimestampBR(value)
      },
      y: { formatter: value => `${formatInteger(value)} solicitações` }
    }
  };
}

function createInteracoesChartOptions(chartHeight, categories, colors) {
  return {
    chart: {
      type: "bar",
      height: chartHeight,
      parentHeightOffset: 0,
      toolbar: { show: false }
    },
    colors,
    plotOptions: {
      bar: { distributed: true, borderRadius: 4, columnWidth: "54%" }
    },
    dataLabels: {
      enabled: true,
      formatter: value => formatInteger(value),
      style: {
        colors: colors,
        fontSize: "12px",
        fontWeight: 600
      },
      background: {
        enabled: true,
        foreColor: "#fff",
        borderRadius: 4,
        padding: 10,
        opacity: 0.8,
        borderWidth: 1,
        borderColor: "#d4dce8"
      }
    },
    grid: { borderColor: "#dfe7f5", strokeDashArray: 4 },
    legend: { show: false },
    xaxis: {
      categories,
      labels: { style: { colors: "#5f6b7a", fontSize: "12px" } }
    },
    yaxis: {
      min: 0,
      labels: {
        formatter: value => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    tooltip: {
      intersect: false,
      y: { formatter: value => `${formatInteger(value)} solicitações` }
    }
  };
}

function createRankingChartOptions(chartHeight, categories) {
  return {
    chart: {
      type: "bar",
      height: chartHeight,
      parentHeightOffset: 0,
      toolbar: { show: false }
    },
    colors: [RANKING_COLOR],
    plotOptions: {
      bar: { horizontal: true, borderRadius: 4, barHeight: "72%" }
    },
    dataLabels: {
      enabled: true,
      formatter: value => formatInteger(value),
      style: {
        colors: [RANKING_COLOR],
        fontSize: "12px",
        fontWeight: 600
      },
      background: {
        enabled: true,
        foreColor: "#fff",
        borderRadius: 4,
        padding: 10,
        opacity: 0.8,
        borderWidth: 1,
        borderColor: "#d4dce8"
      }
    },
    grid: { borderColor: "#dfe7f5", strokeDashArray: 4 },
    legend: { show: false },
    xaxis: {
      categories,
      labels: {
        formatter: value => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    yaxis: {
      labels: {
        maxWidth: 260,
        style: { colors: "#3d4b63", fontSize: "12px" }
      }
    },
    tooltip: {
      intersect: false,
      y: { formatter: value => `${formatInteger(value)}` }
    }
  };
}

export default {
  name: "OperacionalTab",

  components: {
    SummaryCard
  },

  props: {
    isActive: { type: Boolean, default: false },
    totais: {
      type: Object,
      default: () => ({ solicitacoes: 0, aprovadas: 0, negadas: 0 })
    },
    volumePorPeriodo: { type: Array, default: () => [] },
    interacoes: {
      type: Object,
      default: () => ({
        aprovadas: 0,
        negadas: 0,
        canceladas: 0,
        sem_supervisor: 0,
        erro: 0,
        criadas: 0
      })
    },
    rankingSupervisores: { type: Array, default: () => [] },
    rankingUsuarios: { type: Array, default: () => [] },
    dataInicial: { type: String, default: "" },
    dataFinal: { type: String, default: "" }
  },

  data() {
    return {
      chartRefreshTick: 0,
      dialogs: {
        volume: false,
        interacoes: false,
        supervisores: false,
        usuarios: false
      }
    };
  },

  computed: {
    summaryCards() {
      return [
        {
          key: "total-solicitacoes",
          title: "Total de solicitações",
          value: formatInteger(this.totais.solicitacoes),
          variant: "primary"
        },
        {
          key: "total-aprovadas",
          title: "Total de solicitações aprovadas",
          value: formatInteger(this.totais.aprovadas),
          variant: "success"
        },
        {
          key: "total-negadas",
          title: "Total de solicitações negadas",
          value: formatInteger(this.totais.negadas),
          variant: "danger"
        }
      ];
    },

    volumeSeries() {
      const items = toArray(this.volumePorPeriodo);
      if (!items.length) return [];
      const toPoints = key =>
        items.map(item => ({
          x: `${item.data}T12:00:00`,
          y: toNumber(item[key])
        }));
      return [
        { name: "Total", data: toPoints("total") },
        { name: "Aprovadas", data: toPoints("aprovadas") },
        { name: "Negadas", data: toPoints("negadas") },
        { name: "Outros", data: toPoints("outros") }
      ];
    },

    volumeTickAmount() {
      return Math.min(Math.max(1, toArray(this.volumePorPeriodo).length - 1), 8);
    },

    volumeChartOptions() {
      return createVolumeChartOptions("100%", this.volumeTickAmount);
    },

    volumeDialogOptions() {
      return createVolumeChartOptions(520, this.volumeTickAmount);
    },

    volumeRenderKey() {
      return ["preview", this.chartRefreshTick, this.dataInicial, this.dataFinal].join("|");
    },

    volumeDialogRenderKey() {
      return ["dialog", this.chartRefreshTick, this.dataInicial, this.dataFinal].join("|");
    },

    interacoesCategories() {
      return ["Aprovadas", "Negadas", "Canceladas", "Sem Supervisor", "Erro", "Criadas"];
    },

    interacoesColors() {
      return [
        STATUS_COLORS.aprovadas,
        STATUS_COLORS.negadas,
        STATUS_COLORS.canceladas,
        STATUS_COLORS.sem_supervisor,
        STATUS_COLORS.erro,
        STATUS_COLORS.criadas
      ];
    },

    interacoesSeries() {
      const i = this.interacoes || {};
      const values = [
        toNumber(i.aprovadas),
        toNumber(i.negadas),
        toNumber(i.canceladas),
        toNumber(i.sem_supervisor),
        toNumber(i.erro),
        toNumber(i.criadas)
      ];
      if (values.every(v => v === 0)) return [];
      return [{ name: "Solicitações", data: values }];
    },

    interacoesChartOptions() {
      return createInteracoesChartOptions("100%", this.interacoesCategories, this.interacoesColors);
    },

    interacoesDialogOptions() {
      return createInteracoesChartOptions(520, this.interacoesCategories, this.interacoesColors);
    },

    supervisoresItems() {
      const items = toArray(this.rankingSupervisores).filter(item => {
        if (!item || !item.nome) return false;
        return (
          String(item.nome)
            .trim()
            .toLowerCase() !== "sem supervisor"
        );
      });
      return sortByMetricDesc(items, "interacoes");
    },

    supervisoresCategories() {
      return this.supervisoresItems.slice(0, INITIAL_RANKING_LIMIT).map(item => item.nome);
    },

    supervisoresSeries() {
      if (!this.supervisoresItems.length) return [];
      return [
        {
          name: "Interações",
          data: this.supervisoresItems
            .slice(0, INITIAL_RANKING_LIMIT)
            .map(item => toNumber(item.interacoes))
        }
      ];
    },

    supervisoresDialogCategories() {
      return this.supervisoresItems.map(item => item.nome);
    },

    supervisoresDialogSeries() {
      if (!this.supervisoresItems.length) return [];
      return [
        { name: "Interações", data: this.supervisoresItems.map(item => toNumber(item.interacoes)) }
      ];
    },

    supervisoresChartOptions() {
      return createRankingChartOptions("100%", this.supervisoresCategories);
    },

    supervisoresDialogOptions() {
      return createRankingChartOptions(
        this.rankingDialogHeight(this.supervisoresItems),
        this.supervisoresDialogCategories
      );
    },

    usuariosItems() {
      const items = toArray(this.rankingUsuarios).filter(item => item && item.nome);
      return sortByMetricDesc(items, "solicitacoes");
    },

    usuariosCategories() {
      return this.usuariosItems.slice(0, INITIAL_RANKING_LIMIT).map(item => item.nome);
    },

    usuariosSeries() {
      if (!this.usuariosItems.length) return [];
      return [
        {
          name: "Solicitações",
          data: this.usuariosItems
            .slice(0, INITIAL_RANKING_LIMIT)
            .map(item => toNumber(item.solicitacoes))
        }
      ];
    },

    usuariosDialogCategories() {
      return this.usuariosItems.map(item => item.nome);
    },

    usuariosDialogSeries() {
      if (!this.usuariosItems.length) return [];
      return [
        {
          name: "Solicitações",
          data: this.usuariosItems.map(item => toNumber(item.solicitacoes))
        }
      ];
    },

    usuariosChartOptions() {
      return createRankingChartOptions("100%", this.usuariosCategories);
    },

    usuariosDialogOptions() {
      return createRankingChartOptions(
        this.rankingDialogHeight(this.usuariosItems),
        this.usuariosDialogCategories
      );
    }
  },

  methods: {
    rankingDialogHeight(items) {
      return Math.max(RANKING_DIALOG_MIN_HEIGHT, toArray(items).length * RANKING_DIALOG_BAR_HEIGHT);
    },

    refreshCharts() {
      this.chartRefreshTick += 1;
    },

    resetSelection() {
      this.chartRefreshTick += 1;
    }
  },

  watch: {
    isActive(value) {
      if (!value) return;
      this.$nextTick(() => this.refreshCharts());
    },

    volumePorPeriodo() {
      this.$nextTick(() => this.refreshCharts());
    }
  },

  mounted() {
    if (this.isActive) {
      this.$nextTick(() => this.refreshCharts());
    }
  }
};
</script>

<style scoped>
.monitorsys-row {
  margin-left: -6px !important;
  margin-right: -6px !important;
}

.monitorsys-row > [class*="col-"] {
  padding: 6px !important;
}

.panel-card {
  border-color: #d9e2ef !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  border-radius: 18px 6px 18px 6px !important;
  display: flex;
  flex-direction: column;
  min-height: 420px;
  height: 420px;
  max-height: 420px;
}

.panel-dialog {
  border-color: #d9e2ef !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.panel-card__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 16px 16px 0;
}

.panel-card__header--dialog {
  flex: 0 0 auto;
  padding: 16px;
}

.panel-card__title {
  color: #0a1f44;
  font-size: 16px;
  font-weight: 700;
}

.panel-card__expand {
  height: 30px !important;
  min-width: 36px !important;
  padding: 0 8px !important;
}

.panel-card__content {
  flex: 1 1 0;
  min-height: 0;
  padding-bottom: 16px !important;
}

.panel-card__dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.panel-card__dialog-content--scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
}

::v-deep .monitorsys-dialog-content .v-dialog {
  margin: 24px auto;
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
}

.panel-card__empty {
  align-items: center;
  color: #5f6b7a;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 320px;
  text-align: center;
}

.monitorsys-action-button {
  border-color: #c7d1dc !important;
  box-shadow: none !important;
  color: #6f7d8c !important;
  font-size: 11px !important;
  font-weight: 500;
  letter-spacing: 0.01em !important;
  text-transform: none !important;
}

.monitorsys-action-button::before {
  background-color: transparent !important;
}

.monitorsys-action-button .v-icon {
  color: #748291 !important;
}

@media (max-width: 959px) {
  .panel-card {
    height: auto;
    min-height: 420px;
    max-height: none;
  }

  .panel-card__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .panel-card__expand {
    align-self: flex-end;
  }
}
</style>
